<template>
  <el-container class="OrderForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-80"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="거래처" prop="customer_id">
              <ACustomerSelector
                v-model="data.customer_name"
                buyer
                confirmChange
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="업체담당자" prop="customer_charger">
              <el-input v-model="data.customer_charger" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="담당자" prop="charger">
              <el-input v-model="data.charger" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="발주번호" prop="code">
              <el-input v-model="data.code" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="발주일" prop="order_date">
              <ADatePicker v-model="data.order_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="입고일" prop="valid_date">
              <ADatePicker v-model="data.valid_date" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="매입일" prop="inbound_date">
              <ADatePicker
                v-model="data.inbound_date"
                :disabled="checkStatusFlag"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="도착지" prop="destination ">
              <el-input v-model="data.destination" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ATradeTable
        ref="trade"
        :items="data.details"
        @changedSum="handleChangedSum"
      />
      <el-dialog
        title="발주서 미리보기"
        top="10"
        custom-class="printform-dialog"
        :visible.sync="childdialogVisible"
        append-to-body
        destroy-on-close
        :close-on-click-modal="false"
      >
        <OrderPrintForm
          :data="form_data"
          @completed="handleCompleted"
        ></OrderPrintForm>
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="sum === 1 || isOrder || !has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{
          isNew ? $t("button.register") : $t("button.modify")
        }}
        (F4)</el-button
      >
      <el-button v-if="!isNew" @click="handleClickPrint">발주서발행</el-button>
      <el-button @click="handleClickClear">초기화</el-button>
      <el-button
        v-if="!isNew"
        :disabled="isOrder || disabled || !has_grant_write"
        type="danger"
        @click="clickDel"
        >삭 제</el-button
      >
      <div v-if="isOrder" class="inline pl-default">
        <el-tag>입고등록</el-tag>
      </div>
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import { order_form } from "@/common/mixins/order_form";
import OrderPrintForm from "./OrderPrintForm";

export default {
  name: "OrderForm",
  mixins: [form, order_form],
  components: { OrderPrintForm },
  data() {
    return {
      title: this.$t("title.order"),
      childdialogVisible: false,
      working: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          code: "",
          customer_id: 0,
          order_date: this.util.getDate(0),
          valid_date: this.util.getDate(1),
          charge_id: null,
          customer_charger: "",
          location: "",
          customer_name: "",
          status_flag: "N",
          tel: "",
          fax: "",
          price: 0,
          cost: 0,
          owner: "",
          details: [],
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleClickRegister() {
      if (this.disabled || this.isOrder || !this.has_grant_write) {
        return;
      }
      if (this.working) {
        return;
      }
      const res = await this.api.selectOrder(this.data.id);
      const data = res.data
      const result = data.details.some(d => d.status_flag !== '0')
      if(result){
        this.util.notify_warning(
          this,
          this.title,
          "입고등록 된 항목이 있습니다. 확인 후 재시도해 주세요."
        );
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        let details = this.getDetails();
        if (details.length < 1) {
          this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
          return;
        }
        if (this.isNew && this.util.isPastDate(this.data.order_date)) {
          this.util.confirm(
            this,
            this.title,
            "발주일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }
        this.working = true;
        this.doRegister();
      });
    },
    handleClickPrint() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.openDialog(this.data);
      });
    },
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.childdialogVisible = true;
    },
    handleCompleted(message) {
      this.childdialogVisible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleSelectUser(c) {
      if (typeof c === "string") {
        this.data.charge_id = null;
        this.data.customer_charger = c;
      } else {
        this.data.charge_id = c.id;
        this.data.customer_charger = c.name;
      }
    },
    doRegister() {
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      // data.order_date = this.util.getDateString(data.order_date);
      // data.valid_date = this.util.getDateString(data.valid_date);
      data.details = this.getDetails();
      if (this.isNew) {
        this.api.createOrder(data).then((res) => {
          this.working = false;
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("create", "등록되었습니다.");
          }
        });
      } else {
        this.api.updateOrder(data).then((res) => {
          if (res.error !== this.system.noError) {
            this.notifyError(res.message);
          } else {
            this.completed("update", "수정되었습니다.");
          }
        });
      }
    },
    clickDel() {
      this.util.confirm_delete(
        this,
        "발주[" + this.data.code + "]",
        this.doDelete
      );
    },
    doDelete() {
      const data = this.organizeData();
      this.api.deleteOrder(data).then((res) => {
        if (res.error !== this.system.noError) {
          this.notifyError(res.message);
        } else {
          this.completed("delete", "삭제되었습니다.");
        }
      });
    },
    /** 데이터 값 정리 */
    organizeData() {
      let param = Object.assign({}, this.data);
      //param.crn = this.util.remove_dash(param.crn);
      //param.ssn = this.util.remove_dash(param.ssn);
      return param;
    },
    notifyError(message) {
      this.util.notify_error(this, "발주", message);
    },
    completed(action, message) {
      const options = this.util.get_notify_options("s", "발주", message);
      this.$emit("completed", action, options);
    },
  },
};
</script>
